import { DataTypes } from "../../../Common/Data/DataTypes";
import { BaseJSONXMLElement } from "./BaseJSONXMLElement";

export class JSONXMLObjectElement extends BaseJSONXMLElement {
    readonly __type: string = "jsonobject";
    readonly name: string = "Object Value";
    readonly ordinal: number = 4;
    readonly outputType: DataTypes = DataTypes.OBJECT;
    readonly styleElement: boolean = false;
}
